export default __webpack_public_path__ + "static/slider2-7dd6a1f29e60d827722582693c83c1d1.jpg";